import { secondsToFormattedLabel, formattedLabelToSeconds } from '../app/utils/date';

import './highlight-capture-plugin.scss';

const { Clappr } = boxcast.libs;
const { UICorePlugin, Events, $ } = Clappr;

export default class HighlightCapturePlugin extends UICorePlugin {
  get supportedVersion() {
    return { min: '0.4.0' };
  }

  get name() {
    return 'highlight-capture';
  }

  get attributes() {
    return { class: this.name };
  }

  constructor(core) {
    super(core);
    const options = core.options.highlightCapturePlugin || {};
    this._onPreview = options.onPreview || function () {};
    this._onSave = options.onSave || function () {};
  }

  bindEvents() {
    this.listenTo(
      this.core.mediaControl,
      Events.MEDIACONTROL_RENDERED,
      this._onMediaControlRendered
    );
  }

  destroy() {
    super.destroy();

    this._$form.find('.close').off('click');
    this._$form.find('.preview').off('click');
    this._$form.find('.save').off('click');
    this._$form.find('input,select').off('keydown');
  }

  _getCurrentTime() {
    // XXX: playback.getCurrentTime is often wildly inaccurate. Asking the <video> element directly is better.
    //var time = this.core.getCurrentPlayback().getCurrentTime();
    var time = this.core.$el.find('video, audio').get(0).currentTime;
    console.log(
      'Clicked at',
      time,
      ' on video element. Playback reports',
      this.core.getCurrentPlayback().getCurrentTime()
    );
    return time;
  }

  _getVideoDuration() {
    //return this.core.getCurrentPlayback().getDuration();
    return this.core.$el.find('video, audio').get(0).duration;
  }

  _getFormSelections() {
    var name = this._$form.find('.description').val();
    var start = formattedLabelToSeconds(this._$form.find('.start-time').val());
    console.log('start is', start, 'from', this._$form.find('.start-time').val());
    var duration =
      parseInt(this._$form.find('.duration').val(), 10) *
      parseInt(this._$form.find('.duration-relative').val(), 10);
    var end = start + duration;
    start = Math.max(0, start);
    end = Math.max(0, end);
    start = Math.min(start, this._getVideoDuration());
    end = Math.min(end, this._getVideoDuration());
    if (start > end) {
      [start, end] = [end, start];
    }
    var fnClose = () => this._onCloseForm();
    return { start, end, name, fnClose };
  }

  _onMediaControlRendered() {
    const playback = this.core.getCurrentPlayback();
    if (playback.name == 'hls') {
      this._appendCameraIcon();
      this._appendForm();
    } else {
      console.log(
        'Playback does not support time-to-segment mapping; cannot load highlight capture plugin.'
      );
    }
  }

  _appendForm() {
    this._$form = $(FORM_HTML);
    this._$form.hide();
    this._$form.find('.close').on('click', () => this._onCloseForm());
    this._$form.find('.preview').on('click', () => this._onPreview(this._getFormSelections()));
    this._$form.find('.save').on('click', () => this._onSave(this._getFormSelections()));
    this._$form.find('.refresh-start-time').on('click', (e) => this._updateStartTime(e));
    this._$form.find('input,select').on('keydown', (e) => e.stopPropagation());

    if (this._$form[0]) {
      // Clappr 0.4+
      this.core.mediaControl.$el.append(this._$form[0]);
    } else {
      this.core.mediaControl.$el.append(this._$form);
    }
  }

  _appendCameraIcon() {
    const mc = this.core.mediaControl;
    mc.$('.media-control-right-panel .media-control-icon').last().after(CAMERA_HTML);
    mc.$('.highlight-capture-plugin-camera-container button').click((e) => this._onCameraClick(e));
  }

  _onCameraClick(e) {
    const playback = this.core.getCurrentPlayback();
    this._wasPlaying = playback.isPlaying();
    this.core.mediaControl.pause();
    this.core.mediaControl.setKeepVisible();
    this._updateStartTime();
    this._$form.show();
  }

  _updateStartTime() {
    var clickedAtTime = this._getCurrentTime();
    this._$form.find('.start-time').val(secondsToFormattedLabel(clickedAtTime));
  }

  _onCloseForm() {
    this._$form.hide();
    this.core.mediaControl.resetKeepVisible();
    if (this._wasPlaying) {
      this.core.getCurrentPlayback().play();
    }
  }
}

const CAMERA_HTML = `
<div class="highlight-capture-plugin-camera-container" style="padding: 0; margin-top: 6px;">
  <button type="button" class="boxcast-clappr-button">
    <i class="fa fa-camera" />
  </button>
</div>
`;

const FORM_HTML = `
<div class="highlight-form">
  <div class="close-container">
    <i class="close fa fa-times-circle" />
  </div>
  <h3>Capture a Highlight</h3>
  <div style="display:flex;">
    <div style="width:75%;text-align:left;margin-right:10px;">
      <div style="margin-bottom:10px">
        Description<br>
        <input type="text" class="description form-control" placeholder="Enter a name for this clip..." maxlength="255">
      </div>
      <div style="display:flex">
        <div style="margin-right:10px;line-height:32px">
          <select class="duration form-control">
            <option selected value="10">10 sec</option>
            <option value="20">20 sec</option>
            <option value="30">30 sec</option>
            <option value="40">40 sec</option>
            <option value="50">50 sec</option>
            <option value="60">60 sec</option>
            <option value="90">90 sec</option>
            <option value="120">2 min</option>
            <option value="180">3 min</option>
          </select>
        </div>
        <div style="margin-right:10px;line-height:32px">
          <select class="duration-relative form-control">
            <option selected value="-1">before</option>
            <option value="1">after</option>
          </select>
        </div>
        <div style="line-height:32px;margin-right:10px;">
          <input type="text" class="start-time form-control">
        </div>
        <div style="line-height:32px">
          <i class="refresh-start-time fa fa-refresh"></i>
        </div>
      </div>
    </div>
    <div style="width:25%;">
      &nbsp;<br>
      <button class="preview btn btn-warning btn-block">Preview</button>
      <button class="save btn btn-primary btn-block">Save Highlight</button>
    </div>
  </div>
</div>
`;



// WEBPACK FOOTER //
// ./player/highlight-capture-plugin.js